// src/components/Alerts.js
import React from 'react';
import { AlertTriangle } from 'react-feather'; // Import icon

function Alerts({ alerts }) {
  if (!alerts || alerts.length === 0) {
    return null;
  }

  return (
    <div className="alerts-card">
      {/* Use the same h2 structure as other components for consistency */}
      <div className="content-box-header" style={{ marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '1px solid var(--warning-border)' }}>
        <h2><AlertTriangle size={20} className="icon-yellow" /> Potential Issues & Flags</h2>
      </div>
      <ul>
        {alerts.map((alert, index) => (
          <li key={index}>{alert}</li>
        ))}
      </ul>
    </div>
  );
}

export default Alerts;
